import {Types} from 'mongoose';
import * as dis2 from '../dispossitions/dispossitions.data';
import {
    ACTIVITY_TYPE_ORG_NETWORKING_ID,
    ACTIVITY_TYPE_ORG_NETWORKING_OTHER_ID,
    ACTIVITY_TYPE_ORGANIZATIONAL_NETWORKING,
} from './activity-type.const';
import {CONFLICT_RESOLUTION} from './conflict-resolutions/conflict-resolution.data';
import {ORGANIZATIONAL_DEVELOPMENT} from './organizational-development/organizational-development.data';
import {ORGANIZATIONAL_EVENTS} from './organizational-events/organizational-events.data';
import {OUTREACH} from './outreach/outreach.data';
import {OTHER_FEE} from './payamnets.data';
import {TRAINING} from './training/training.data';

export const ORGANIZATIONAL_NETWORKING = {
    _id: new Types.ObjectId(ACTIVITY_TYPE_ORG_NETWORKING_ID),
    label: ACTIVITY_TYPE_ORGANIZATIONAL_NETWORKING,
    icon: 'organizationalNetworking',
    description: 'Events organized by other entities',
    subTypes: [
        {
            _id: new Types.ObjectId(ACTIVITY_TYPE_ORG_NETWORKING_OTHER_ID),
            value: 'other',
            label: 'Other',
            defaultDisposition: dis2.ON_OTH_OPEN_PENDING,
            dispositions: [dis2.ON_OTH_OPEN_PENDING, dis2.ON_OTH_ATTENDED, dis2.ON_OTH_OTHER],
            paymentIn: [OTHER_FEE],
            paymentOut: [OTHER_FEE],
        },
    ],
};

export const PMP_QUARTERLY_MEETING = {
    _id: new Types.ObjectId('65f062bc2d71dfb4e288119e'),
    label: 'PMP Quarterly Meeting',
    defaultDisposition: dis2.ME_PMPQM_OPEN_PENDING,
    dispositions: [dis2.ME_PMPQM_OPEN_PENDING, dis2.ME_PMPQM_COMPLETED, dis2.ME_PMPQM_CANCELLED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const MEETINGS = {
    _id: new Types.ObjectId('65f062bc2d71dfb4e188120e'),
    label: 'Meetings',
    icon: 'meetings',
    subTypes: [PMP_QUARTERLY_MEETING],
};

export const OTHER_ACTIVITIES = {
    _id: new Types.ObjectId('65f062bc2d71dfb4e188121e'),
    label: 'Other',
    defaultDisposition: dis2.OT_OT_OPEN_PENDING,
    dispositions: [dis2.OT_OT_OPEN_PENDING, dis2.OT_OT_COMPLETED, dis2.OT_OT_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const OTHER = {
    _id: new Types.ObjectId('65f062bc2d71dfb4e188122e'),
    label: 'Other',
    icon: 'other',
    subTypes: [OTHER_ACTIVITIES],
};

export const ACTIVITY_TYPE = {
    type: 'Activity Type',
    category: 'System',
    value: [
        CONFLICT_RESOLUTION,
        TRAINING,
        OUTREACH,
        // VOLUNTEER, 65f062bc2d71dfb4e188011f
        ORGANIZATIONAL_EVENTS,
        ORGANIZATIONAL_NETWORKING,
        ORGANIZATIONAL_DEVELOPMENT,
        // MEETINGS,
        // OTHER, 65f062bc2d71dfb4e188122e
    ],
};
